//Register constants and services used for dependency injection
require('./services/axiosInstance')
require('./services/LoginService')
require('./services/DataService')
require('./services/DashboardService')
require('./services/TechnicalService')
require('./services/AdminService')
